module.exports = "# PDF Resizer - Easily Resize PDF Files Online\r\n\r\nResize your PDF files to a new paper size by uploading them below."


//////////////////
// WEBPACK FOOTER
// ./src/containers/PdfResize/pdf-resize-header.md
// module id = 1188
// module chunks = 0